import styled from "@emotion/styled";

const Card = styled.div`
    background-color: #FFFFFF;
    box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
    border-radius: 20px;
`

export default Card